<template>
	<div>
		<a-row>
			<a-col :span="6">
				<el-card class="box-card">
					<a-row>
						<a-col style="text-align: center;" :span="12"><img class="index_img" src="../../static/img/home/order.png" alt="" /></a-col>
						<a-col :span="12">
							<div class="litile_title item">今日订单总数</div>
							<div class="text item">{{ data.orderCount }}</div>
						</a-col>
					</a-row>
				</el-card>
			</a-col>
			<a-col :span="6">
				<el-card class="box-card">
					<a-row>
						<a-col style="text-align: center;" :span="12"><img class="index_img" src="../../static/img/home/visitor.png" alt="" /></a-col>
						<a-col :span="12">
							<div class="litile_title item">今日访客</div>
							<div class="text item" v-if="data.visitorCount == undefined">今日暂无访客</div>
							<div class="text item" v-else>{{ data.visitorCount }} 人</div>
						</a-col>
					</a-row>
				</el-card>
			</a-col>
			<a-col :span="6">
				<el-card class="box-card">
					<a-row>
						<a-col style="text-align: center;" :span="12"><img class="index_img" src="../../static/img/home/money.png" alt="" /></a-col>
						<a-col :span="12">
							<div class="litile_title item">今日营业额</div>
							<div class="text item" v-if="data.turnover == undefined">￥0</div>
							<div class="text item" v-else>￥{{ data.turnover / 100 }}</div>
						</a-col>
					</a-row>
				</el-card>
			</a-col>
			<a-col :span="6">
				<el-card class="box-card">
					<a-row>
						<a-col style="text-align: center;" :span="12"><img class="index_img" src="../../static/img/home/sumMoney.png" alt="" /></a-col>
						<a-col :span="12">
							<div class="litile_title item">店铺销售总额</div>
							<div class="text item" v-if="data.sumTurnover == undefined">￥0</div>
							<div class="text item" v-else>￥{{ data.sumTurnover / 100 }}</div>
						</a-col>
					</a-row>
				</el-card>
			</a-col>
		</a-row>

		<a-row style="margin-top: 50px;">
			<a-col :span="12">
				<a-card style="width: 90%;margin: auto;" :headStyle="{ background: '#F2F6FC', padding: '0px 0px 0px 20px' }">
					<span slot="title" style="font-weight: bold;">商品总览</span>
					<a-row style="text-align: center;">
						<a-col :span="6">
							<div class="font-two" v-if="storePandect.soldOutCount == undefined">0</div>
							<div class="font-two" v-else>{{ storePandect.soldOutCount }}</div>
							<div style="font-size: 18px;">已下架</div>
						</a-col>
						<a-col :span="6">
							<div class="font-two" v-if="storePandect.putAwayCount == undefined">0</div>
							<div class="font-two" v-else>{{ storePandect.putAwayCount }}</div>
							<div style="font-size: 18px;">已上架</div>
						</a-col>
						<a-col :span="6">
							<div class="font-two" v-if="storePandect.salesCount == undefined">0</div>
							<div class="font-two" v-else>{{ storePandect.salesCount }}</div>
							<div style="font-size: 18px;">销售数量</div>
						</a-col>
						<a-col :span="6">
							<div class="font-two" v-if="storePandect.productCount == undefined">0</div>
							<div class="font-two" v-else>{{ storePandect.productCount }}</div>
							<div style="font-size: 18px;">全部商品</div>
						</a-col>
					</a-row>
				</a-card>
			</a-col>
			<a-col :span="12">
				<a-card
					style="width: 90%;
				margin: auto;"
					:headStyle="{ background: '#F2F6FC', padding: '0px 0px 0px 20px' }"
				>
					<span slot="title" style="font-weight: bold;">用户总览</span>
					<a-row style="text-align: center;">
						<a-col :span="6">
							<div class="font-two" v-if="storePandect.todayAccount == undefined">0</div>
							<div class="font-two" v-else>{{ storePandect.todayAccount }}</div>
							<div style="font-size: 18px;">今日访客</div>
						</a-col>
						<a-col :span="6">
							<div class="font-two" v-if="storePandect.yesterdayAccount == undefined">0</div>
							<div class="font-two" v-else>{{ storePandect.yesterdayAccount }}</div>
							<div style="font-size: 18px;">昨日访客</div>
						</a-col>
						<a-col :span="6">
							<div class="font-two" v-if="storePandect.monthAccount == undefined">0</div>
							<div class="font-two" v-else>{{ storePandect.monthAccount }}</div>
							<div style="font-size: 18px;">本月访客</div>
						</a-col>
						<a-col :span="6">
							<div class="font-two" v-if="storePandect.attentionAccount == undefined">0</div>
							<div class="font-two" v-else>{{ storePandect.attentionAccount }}</div>
							<div style="font-size: 18px;">关注数量</div>
						</a-col>
					</a-row>
				</a-card>
			</a-col>
		</a-row>

		<a-row style="margin-top: 50px;">
			<a-col :span="12">
				<div>
					<a-row>
						<a-col :span="20">
							<div
								style="width: 90%;
							margin: auto;font-size: 25px;"
							>
								<div>账户余额：￥{{ balance }}</div>
							</div>
						</a-col>
						<a-col :span="4"><a-button type="primary" @click="showModal">提现</a-button></a-col>
					</a-row>
				</div>
				<div style="width: 80%;margin: auto;">
					<a-row>
						<a-col :span="20" style="margin-top: 20px;">
							<a-tooltip>
								<template slot="title">
									交易中的订单~
								</template>
								<a style="font-size: 23px;" @click="dealingList">交易中</a>
							</a-tooltip>
							<div style="color: gray;">进行中的交易</div>
						</a-col>
						<a-col :span="4">
							<div style="font-size: 23px;line-height: 3;color: red;">￥{{ dealing }}</div>
						</a-col>
					</a-row>
				</div>
				<div style="width: 80%;margin: auto;">
					<a-row>
						<a-col :span="20" style="margin-top: 20px;">
							<a-tooltip>
								<template slot="title">
									结算中的订单~
								</template>
								<a style="font-size: 23px;" @click="closeingList">结算中</a>
							</a-tooltip>
							<div style="color: gray;">订单管理中已完成的订单十日后进入账户余额即可提现</div>
						</a-col>
						<a-col :span="4">
							<div style="font-size: 23px;line-height: 3;color: red;">￥{{ closeing }}</div>
						</a-col>
					</a-row>
				</div>

				<div style="width: 80%;margin: auto;">
					<a-row>
						<a-col :span="20" style="margin-top: 20px;">
							<a-tooltip>
								<template slot="title">
									已完成的订单~
								</template>
								<a style="font-size: 23px;" @click="canDrawOrderList">已完成</a>
							</a-tooltip>
							<div style="color: gray;">已完成的订单</div>
						</a-col>
						<a-col :span="4">
							<div style="font-size: 23px;line-height: 3;color: red;">￥{{ data.sumTurnover == undefined ? 0 :data.sumTurnover / 100 }}</div>
						</a-col>
					</a-row>
				</div>
				<div style="width: 80%;margin: auto;">
					<a-row>
						<a-col :span="20" style="margin-top: 20px;">
							<div style="font-size: 23px;">已提现</div>
							<div style="color: gray;"></div>
						</a-col>
						<a-col :span="4">
							<div style="font-size: 23px;line-height: 3;color: red;">￥{{ deposited }}</div>
						</a-col>
					</a-row>
				</div>
			</a-col>
			<a-col :span="12">
				<!-- 为ECharts准备一个具备大小（宽高）的Dom -->
				<div id="main" style="width: 600px;height:400px;"></div>
			</a-col>
		</a-row>
		<a-modal v-model="visible" title="提现" @ok="depositSubmit" cancelText="取消" okText="确认">
			<div>
				<a-form-model ref="ruleForm" :rules="rules" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
					<a-form-model-item label="提现方式">
						<a-radio-group default-value="ali" v-model="form.depositWay" size="large">
							<a-radio-button value="1">
								<a-icon type="alipay" />
								支付宝
							</a-radio-button>
							<a-radio-button value="0">
								<a-icon type="credit-card" />
								银行卡
							</a-radio-button>
						</a-radio-group>
					</a-form-model-item>
					<a-form-model-item v-if="form.depositWay == '1'" label="支付宝姓名" prop="aliName"><a-input v-model="form.aliName" /></a-form-model-item>
					<a-form-model-item v-if="form.depositWay == '1'" label="支付宝账号" prop="aliAccount"><a-input v-model="form.aliAccount" /></a-form-model-item>

					<a-form-model-item v-if="form.depositWay == '0'" label="银行卡账号" prop="bankNumber"><a-input v-model="form.bankNumber" /></a-form-model-item>
					<a-form-model-item v-if="form.depositWay == '0'" label="持卡人姓名" prop="bankname"><a-input v-model="form.bankname" /></a-form-model-item>
					<a-form-model-item v-if="form.depositWay == '0'" label="开户银行" prop="bankBelong"><a-input v-model="form.bankBelong" /></a-form-model-item>

					<a-form-model-item label="提现金额" prop="money">
						<a-input-number
							placeholder="请输入提现金额"
							:min="10"
							:max="balance"
							style=" margin-right: 8px;width: 120px;"
							v-model="form.money"
							:precision="2"
							:formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
							:parser="value => value.replace(/\￥\s?|(,*)/g, '')"
						/>
					</a-form-model-item>

					<a-form-model-item label="支付密码" prop="drawPass">
						<a-input-password style="width: 50%" v-model="form.drawPass" />
						<a-tooltip style="margin-left: 15px;" placement="left" title="帝全App -> 我的 -> 其他设置 -> 设置支付密码">
							<a-icon style="font-size: 17px;" type="question-circle" theme="filled" />
						</a-tooltip>
					</a-form-model-item>
				</a-form-model>
			</div>
		</a-modal>

		<a-modal width="1300px" v-model="closeingVisible" okText="确认" cancel-text="关闭" title="结算中订单" @ok="handleOk">
			<a-table :columns="closeColumns" :pagination="closePagination" :data-source="closeData" @change="closePageHandle">
				<span slot="orderMoney" slot-scope="text" style="color: red;">￥{{ text / 100 }}</span>
				<span slot="orderStatus" slot-scope="text">
					<a-tag v-if="text == 1" color="cyan">
						<a-badge status="success" />
						待付款
					</a-tag>
					<a-tag v-if="text == 2" color="red">
						<a-badge status="success" />
						待发货
					</a-tag>
					<a-tag v-if="text == 3" color="purple">
						<a-badge status="success" />
						已发货
					</a-tag>
					<a-tag v-if="text == 4" color="blue">
						<a-badge status="success" />
						待评价
					</a-tag>
					<a-tag v-if="text == 5" color="green">
						<a-badge status="success" />
						交易成功
					</a-tag>
					<a-tag v-if="text == 6" color="#ff5500">
						<a-badge status="success" />
						交易关闭
					</a-tag>
				</span>
			</a-table>
		</a-modal>

		<a-modal width="1300px" v-model="drawingVisible" okText="确认" cancel-text="关闭" title="已完成订单" @ok="handleOk">
			<a-table :columns="closeColumns" :pagination="drawPagination" :data-source="drawData" @change="drawPageHandle">
				<span slot="orderMoney" slot-scope="text" style="color: red;">￥{{ text / 100 }}</span>
				<span slot="orderStatus" slot-scope="text">
					<a-tag v-if="text == 1" color="cyan">
						<a-badge status="success" />
						待付款
					</a-tag>
					<a-tag v-if="text == 2" color="red">
						<a-badge status="success" />
						待发货
					</a-tag>
					<a-tag v-if="text == 3" color="purple">
						<a-badge status="success" />
						已发货
					</a-tag>
					<a-tag v-if="text == 4" color="blue">
						<a-badge status="success" />
						待评价
					</a-tag>
					<a-tag v-if="text == 5" color="green">
						<a-badge status="success" />
						交易成功
					</a-tag>
					<a-tag v-if="text == 6" color="#ff5500">
						<a-badge status="success" />
						交易关闭
					</a-tag>
				</span>
			</a-table>
		</a-modal>

		<a-modal width="1300px" v-model="dealingVisible" okText="确认" cancel-text="关闭" title="交易中订单" @ok="handleOk">
			<a-table :columns="closeColumns" :pagination="dealPagination" :data-source="dealData" @change="dealPageHandle">
				<span slot="orderMoney" slot-scope="text" style="color: red;">￥{{ text / 100 }}</span>
				<span slot="orderStatus" slot-scope="text">
					<a-tag v-if="text == 1" color="cyan">
						<a-badge status="success" />
						待付款
					</a-tag>
					<a-tag v-if="text == 2" color="red">
						<a-badge status="success" />
						待发货
					</a-tag>
					<a-tag v-if="text == 3" color="purple">
						<a-badge status="success" />
						已发货
					</a-tag>
					<a-tag v-if="text == 4" color="blue">
						<a-badge status="success" />
						待评价
					</a-tag>
					<a-tag v-if="text == 5" color="green">
						<a-badge status="success" />
						交易成功
					</a-tag>
					<a-tag v-if="text == 6" color="#ff5500">
						<a-badge status="success" />
						交易关闭
					</a-tag>
				</span>
			</a-table>
		</a-modal>
	</div>
</template>
<script>
import echarts from '../../static/js/echart/echarts.min.js';
import api from '../../api/Api.js';
export default {
	data() {
		return {
			data: {
				orderCount: 0,
				visitorCount: 0,
				turnover: 0,
				sumTurnover: 0,
				residual: 0
			},
			storePandect: {
				soldOutCount: 0,
				putAwayCount: 0,
				salesCount: 0,
				productCount: 0,
				todayAccount: 0,
				yesterdayAccount: 0,
				monthAccount: 0,
				attentionAccount: 0
			},
			form: {
				aliName: '',
				aliAccount: '',
				depositWay: '1',
				bankNumber: '',
				bankname: '',
				bankBelong: '',
				money: '',
				drawPass: ''
			},
			labelCol: { span: 5 },
			wrapperCol: { span: 14 },
			balance: 0,
			dealing: 0,
			deposited: 0,
			closeing: 0,
			visible: false,
			closeingVisible: false,
			dealingVisible: false,
			drawingVisible: false,
			closeColumns,
			closeData: [],
			dealData: [],
			drawData: [],
			closePagination: { current: 1, pageSize: 5, total: 0 },
			dealPagination: { current: 1, pageSize: 5, total: 0 },
			drawPagination: { current: 1, pageSize: 5, total: 0 },
			rules: {
				aliName: [{ required: true, message: '请输入支付宝真实姓名', trigger: 'blur' }],
				aliAccount: [{ required: true, message: '请输入支付宝账号', trigger: 'blur' }],
				bankname: [{ required: true, message: '请输入持卡人姓名', trigger: 'blur' }],
				bankNumber: [{ required: true, message: '请输入银行卡账号', trigger: 'blur' }],
				bankBelong: [{ required: true, message: '请输入开户银行', trigger: 'blur' }],
				money: [{ required: true, message: '请输入提现金额', trigger: 'blur' }],
				drawPass: [{ required: true, message: '请输入支付密码', trigger: 'blur' }]
			}
		};
	},
	mounted() {
		this.getInfo();
		this.getStoreFlow();
		this.getStorePandect();
		this.getStoreBalance();

		this.getCardInfo();
	},
	methods: {
		depositSubmit() {
			this.$refs.ruleForm.validate(valid => {
				if (valid) {
					if (this.form.depositWay == 'bank') {
						this.setBankCard();
					} else if (this.form.depositWay == 'ali') {
						this.setAliCard();
					}
					this.submitStoreDrawApply();
				} else {
					this.$message.warning('请完善表格信息');
					return false;
				}
			});
		},
		getCanDrawList() {
			const that = this;
			let url = 'api/store/v1/admin/canDrawOrderList';
			let param = {
				page: this.drawPagination.current - 1
			};
			api.postRequest(url, param, res => {
				if (res.data.status == 200) {
					that.drawData = res.data.data;
					that.drawPagination.total = res.data.maxCount;
				} else {
					that.$message.error(that.data.message);
				}
			});
		},
		submitStoreDrawApply(){
			const that = this;
			let url = 'api/points/v1/draw/admin/submitStoreDrawApply';
			let param = {
				drawPass: that.form.drawPass,
				drawType: that.form.depositWay,
				money:  that.form.money*100
			};
			api.postRequest(url, param, res => {
				if (res.data.status == 200) {
					this.$message.success('提现成功！将会在1~3个工作日内到账！');
					this.visible = false;
				} else {
					this.$message.error(res.message);
				}
			});
		},
		setAliCard() {
			const that = this;
			let url = 'api/points/v1/draw/ali/addAliCard';
			let param = {
				accountName: that.form.aliName,
				phone: that.form.aliAccount
			};
			api.postRequest(url, param, res => {
				if (res.data.status == 200) {
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		setBankCard() {
			const that = this;
			let url = 'api/points/v1/draw/admin/addCard';
			let param = {
				accountName: that.form.bankname,
				accountNo: that.form.bankNumber,
				bank: that.form.bankBelong
			};
			api.postRequest(url, param, res => {
				if (res.data.status == 200) {
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		getCardInfo() {
			const that = this;
			let url = 'api/points/v1/draw/admin/getCard';
			let param = 1;
			api.postRequest(url, param, res => {
				if (res.data.status == 200) {
					let cardList = res.data.data;
					cardList.forEach(function(item) {
						if (item.status == 0) {
							that.form.bankname = item.accountName;
							that.form.bankNumber = item.accountNo;
							that.form.bankBelong = item.bank;
						} else if (item.status == 1) {
							that.form.aliName = item.accountName;
							that.form.aliAccount = item.accountNo;
						}
					});
				} else {
					that.$message.error(that.data.message);
				}
			});
		},
		getCloseList() {
			const that = this;
			let url = 'api/store/v1/admin/closeOrderList';
			let param = {
				page: this.closePagination.current - 1
			};
			api.postRequest(url, param, res => {
				if (res.data.status == 200) {
					that.closeData = res.data.data;
					that.closePagination.total = res.data.maxCount;
				} else {
					that.$message.error(that.data.message);
				}
			});
		},
		getDealList() {
			const that = this;
			let url = 'api/store/v1/admin/dealOrderList';
			let param = {
				page: this.dealPagination.current - 1
			};
			api.postRequest(url, param, res => {
				if (res.data.status == 200) {
					that.dealData = res.data.data;
					that.dealPagination.total = res.data.maxCount;
				} else {
					that.$message.error(that.data.message);
				}
			});
		},
		getStoreFlow() {
			const that = this;
			let url = 'api/store/v1/admin/taking';
			let param = 1;
			api.postRequest(url, param, res => {
				if (res.data.status == 200) {
					that.data = res.data.data;
				} else {
					that.$message.error(that.data.message);
				}
			});
		},
		getStoreBalance() {
			const that = this;
			let url = 'api/store/v1/admin/storeBalance';
			let param = 1;
			api.postRequest(url, param, res => {
				if (res.status == 200) {
					let temp = res.data.data;
					that.balance = temp.balance / 100;
					that.dealing = temp.dealing / 100;
					that.deposited = temp.deposited / 100;
					that.closeing = temp.closeing / 100;
				}
			});
		},
		getStorePandect() {
			const that = this;
			let url = 'api/store/v1/admin/storePandect';
			let param = 1;
			api.postRequest(url, param, res => {
				if (res.status == 200) {
					that.storePandect = res.data.data;
				}
			});
		},
		getDrawCard() {
			const that = this;
			let url = '/api/points/v1/draw/admin/getCard';
			let param = 1;
			api.postRequest(url, param, res => {
				if (res.status == 200) {
					that.storePandect = res.data.data;
				}
			});
		},
		getInfo() {
			const that = this;
			let url = 'api/store/v1/admin/orderFlow';
			let param = 1;
			api.postRequest(url, param, res => {
				const data = res.data.data;
				console.log(data);
				const date = [];
				const orderCountList = [];
				const sumTurnoverList = [];

				if (res.status == 200) {
					data.forEach((item, index, array) => {
						date.push(item.date);
						orderCountList.push(item.orderCount);
						sumTurnoverList.push(item.sumTurnover / 100);
					});
				}
				this.echartInfo(date, orderCountList, sumTurnoverList);
			});
		},
		drawPageHandle(pagination, filters, sorter) {
			this.drawPagination = pagination;
			this.getCanDrawList();
		},
		closePageHandle(pagination, filters, sorter) {
			this.closePagination = pagination;
			this.getCloseList();
		},
		dealPageHandle(pagination, filters, sorter) {
			this.dealPagination = pagination;
			this.getDealList();
		},
		showModal() {
			this.visible = true;
		},
		canDrawOrderList() {
			this.drawingVisible = true;
			this.getCanDrawList();
		},
		closeingList() {
			this.closeingVisible = true;
			this.getCloseList();
		},
		drawingList() {
			this.drawingVisible = true;
			this.getCanDrawList();
		},
		dealingList() {
			this.dealingVisible = true;
			this.getDealList();
		},
		handleOk(e) {
			this.visible = false;
			this.closeingVisible = false;
			this.dealingVisible = false;
		},
		echartInfo(date, orderCountList, sumTurnoverList) {
			// 基于准备好的dom，初始化echarts实例
			var myChart = echarts.init(document.getElementById('main'));

			// 指定图表的配置项和数据

			// 指定图表的配置项和数据
			var option = {
				title: {
					text: '订单统计',
					subtext: '数据图'
				},
				tooltip: {
					trigger: 'axis'
				},
				legend: {
					data: ['活跃人数']
				},
				toolbox: {
					show: true,
					feature: {
						dataZoom: {
							yAxisIndex: 'none'
						},
						dataView: {
							readOnly: false
						},
						magicType: {
							type: ['line', 'bar']
						},
						restore: {},
						saveAsImage: {}
					}
				},
				xAxis: {
					type: 'category',
					boundaryGap: false,
					data: date
				},
				yAxis: [
					{
						type: 'value',
						axisLabel: {
							formatter: '{value}'
						}
					},
					{
						type: 'value',
						name: '金额',
						interval: 5,
						axisLabel: {
							formatter: '{value}'
						}
					}
				],
				series: [
					{
						name: '订单金额(元)',
						type: 'line',
						data: sumTurnoverList,
						markPoint: {
							data: [
								{
									type: 'max',
									name: '最大值'
								},
								{
									type: 'min',
									name: '最小值'
								}
							]
						},
						markLine: {
							data: [
								{
									type: 'average',
									name: '平均值'
								}
							]
						}
					},
					{
						name: '订单数量',
						type: 'line',
						color: 'skyblue',
						yAxisIndex: 1,
						data: orderCountList,
						markPoint: {
							data: [
								{
									type: 'max',
									name: '最大值'
								},
								{
									type: 'min',
									name: '最小值'
								}
							]
						},
						markLine: {
							data: [
								{
									type: 'average',
									name: '平均值'
								}
							]
						}
					}
				]
			};

			// 使用刚指定的配置项和数据显示图表。
			myChart.setOption(option);
		}
	}
};

const closeColumns = [
	{
		title: '编号',
		dataIndex: 'orderId',
		key: 'orderId'
	},
	{
		title: '订单号',
		dataIndex: 'orderSn',
		key: 'orderSn'
	},
	{
		title: '商品名称',
		dataIndex: 'productName',
		key: 'productName',
		ellipsis: true
	},
	{
		title: '规格',
		dataIndex: 'specification',
		key: 'specification',
		ellipsis: true
	},
	{
		title: '订单金额',
		dataIndex: 'orderMoney',
		key: 'orderMoney',
		scopedSlots: { customRender: 'orderMoney' }
	},
	{
		title: '订单状态',
		dataIndex: 'orderStatus',
		key: 'orderStatus',
		ellipsis: true,
		scopedSlots: { customRender: 'orderStatus' }
	},
	{
		title: '下单时间',
		dataIndex: 'createTime',
		key: 'createTime',
		ellipsis: true
	},
	{
		title: '发货时间',
		dataIndex: 'shippingTime',
		key: 'shippingTime',
		ellipsis: true
	}
];
</script>
<style>
.text {
	font-size: 18px;
	font-weight: bold;
}

.item {
	padding: 10px 0;
}

.box-card {
	width: 320px;
	margin: auto;
}
.index_img {
	width: 100px;
}
.litile_title {
	font-size: 20px;
}
.font-two {
	color: #f56c6c;
	font-size: 30px;
}
</style>
